import styled, {css} from "styled-components";
import PropTypes from "prop-types";
import { device } from "../device";

const ButtonLink = styled.button`
    position: relative;

    align-items: center;
    display: flex;
    height: 40px;
    justify-content: center;
    padding: 0 24px;
    width: fit-content;

    border: 0;
    border-radius: 24px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    line-height: 1px;
    transition: background .1s ease-in-out;
    outline: 0;
    ${props => props.btnType === 'primary' && css`
        background: var(--green1);
        color: var(--brand);
        &:hover {
            background: var(--green2);
            color: var(--brand);
        }
    `}
    ${props => props.withIcon && css`
        @media ${device.lg} {
            padding: 0 32px 0 40px;
        }
        svg {
            left: 14px;
            top: 50%;
            position: absolute;
            display: none;
            transform: translate(0,-50%);
            @media ${device.lg} {
                display: block;
            }
        }
    `}

`;

ButtonLink.propTypes = {
    btnType: PropTypes.string
};

export default ButtonLink